import React, {ReactNode} from 'react';
import WizardConstructionManagement from './WizardConstructionManagement';
import Page, {PageType} from '@episerver/spa-core/Page';
import WizardConstructionManagementPageData from '../../../Models/Content/WizardConstructionManagementPageData';

export default class WizardConstructionManagementPage extends Page<WizardConstructionManagementPageData> {
  public render(): ReactNode | null {
    return <WizardConstructionManagement context={this.getContext()} iContent={this.props.data} />;
  }
}
